import React from 'react';
import Skeleton from 'react-loading-skeleton';

/**
 * Skeleton loader for Related Products section
 * Simplified version for related products grid
 */
export const RelatedProductsSkeleton: React.FC = () => {
  return (
    <div className="card elev-sm" style={{ padding: 0, overflow: 'hidden' }}>
      <Skeleton height={180} style={{ display: 'block' }} />
      <div style={{ padding: 'var(--space-3)' }}>
        <Skeleton height={18} style={{ marginBottom: 6 }} />
        <Skeleton width="40%" height={14} />
      </div>
    </div>
  );
};

export default RelatedProductsSkeleton;
